<template>
  <Menu class="w-[280px]">
    <Menu.Item :icon="MoveIcon" @click="handleMoveClick"> Move </Menu.Item>
  </Menu>
</template>

<script setup lang="ts">
import type { Item } from '@/shared/graphql/router/graphql'
import { Menu } from '@dacr/library'
import { MoveIcon } from '@dacr/icons'
import { openDialog, Dialog } from '@/shared/dialogs/dialog'

const props = defineProps<{
  items: Item[]
}>()
const emit = defineEmits<{
  clicked: []
}>()

const handleMoveClick = () => {
  openDialog(Dialog.MoveItems, {
    props: { ids: props.items.map((item) => item.id) },
  })
  emit('clicked')
}
</script>
